import { getTranslation } from 'src/utilities/translator';
import * as yup from 'yup';

export const validateAllEmail = async (
  emailArray: (string | undefined)[] | undefined,
) => {
  return yup
    .array()
    .of(yup.string().email())
    .validate(emailArray)
    .then(() => true)
    .catch(() => false);
};

export const generateYupSchema = (
  fields: {
    parameter_type: string;
    required: boolean;
    parameter: string;
  }[],
) => {
  const schema: any = {};
  fields
    .filter(item => item.parameter !== 'IS_ACTIVE')
    .forEach(field => {
      let yupSchema: yup.AnySchema;

      switch (field.parameter_type) {
        case 'DROPDOWN':
          yupSchema = yup.string();
          break;
        case 'DATE_PICKER':
          yupSchema = yup.date();
          break;
        case 'MULTIPLE_INPUT':
          yupSchema = yup
            .array()
            .of(yup.string())
            .test(
              'is-email',
              'settings_autoReport_errormessage_invalidEmail',
              validateAllEmail,
            )
            .max(5, 'settings_autoReport_errormessage_maxFiveemail');
          if (field.required) {
            yupSchema = yup
              .array()
              .of(yup.string())
              .min(1)
              .test(
                'is-email',
                'settings_autoReport_errormessage_invalidEmail',
                validateAllEmail,
              )
              .max(5, 'settings_autoReport_errormessage_maxFiveemail');
          }
          break;
        case 'INPUT_TEXT':
        case 'AREA_TEXT':
          yupSchema = yup.string().max(255, 'common_max255char');
          break;
        case 'CHECKLIST':
          yupSchema = yup.array().of(yup.string());
          if (field.required) {
            yupSchema = yup
              .array()
              .of(yup.string())
              .min(1, 'common_fieldIsRequired');
          }
          break;
        default:
          yupSchema = yup.mixed();
      }

      if (field.required) {
        yupSchema = yupSchema.required('common_fieldIsRequired');
      }

      schema[field.parameter] = yupSchema;
    });

  return yup.object().shape(schema).required();
};

export const getSelectPlaceholder = (parameter: string) => {
  switch (parameter) {
    case 'STATUS':
      return getTranslation('settings_autoReport_status_placeholder');
    case 'FILE_TYPE':
      return getTranslation('settings_autoReport_fileType_placeholder');
    case 'REPORT_SCHEDULE':
      return getTranslation('settings_autoReport_schedulePlaceholder');
    default:
      return undefined;
  }
};

export const getAreaTextPlaceholder = (parameter: string) => {
  switch (parameter) {
    case 'DESCRIPTION':
      return getTranslation('settings_autoReport_descriptionPlaceholder');
    default:
      return undefined;
  }
};

export const getMultipleInputPlaceholder = (parameter: string) => {
  switch (parameter) {
    case 'RECIPIENT':
      return getTranslation('common_typeTheRecipient');
    default:
      return undefined;
  }
};
